import axios from "@/api/config";

const xiaoETongLiveInfo = {
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/xiaoETongLiveInfo/pageList`, data);
  },
};

export default xiaoETongLiveInfo;



// WEBPACK FOOTER //
// ./src/api/xiaoETongLiveInfo.js